import { useCallback, useMemo } from "react";
import { UseAudioModeDataArgs } from "./useAudioModeData";
import { SubToPages_pages } from "../../../../editor/Project/api/SubToPages";
import { useNavigate } from "react-router";

export default function useProofListeningNav(
  currentPageId: string | undefined,
  bookInfoFromUrl: UseAudioModeDataArgs["bookInfoFromUrl"],
  pages: SubToPages_pages[],
) {
  const navigate = useNavigate();
  const goBack = useCallback(() => navigate(-1), [navigate]);

  const [previousPage, nextPage] = useMemo(() => {
    if (!pages?.length) return [];
    const idx = pages.findIndex((page) => page.id === currentPageId);
    return [pages[idx - 1]?.pageNumber, pages[idx + 1]?.pageNumber];
  }, [pages, currentPageId]);

  const nav = useMemo(() => {
    const navTo = (pageNumber?: number) => {
      if (typeof pageNumber !== "number") {
        return;
      }
      navigate(`/audio/library/edit/${bookInfoFromUrl.bookId}/${pageNumber}`);
    };

    return {
      prev: {
        canNavigate: previousPage !== undefined,
        navigate: () => navTo(previousPage),
      },
      next: {
        canNavigate: nextPage !== undefined,
        navigate: () => navTo(nextPage),
      },
    };
  }, [previousPage, nextPage, navigate, bookInfoFromUrl.bookId]);

  return {
    goBack,
    nav,
  };
}
